/**
 * カスタムボタンの共通処理
 */
$(function () {
    /* ボタン式チェックボックス */
    $(document).on('click', '.check-button input', function() {
        let label = $(this).parent();
        $(label).toggleClass('active', $(this).prop('checked'));
    });
    /* 閉じるボタン */
    $(document).on('click', '.news-release-message .close', function() {
        let id = $(this).data('id');
        let datas = [];
        datas.push({'name' : 'id', 'value' : id});
        _ajax.post($(this).data('action'), datas, function(response) {
            $('#news_release_message_'+id).addClass('display-none');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });
    // ログイン画面に戻るボタン
    $(document).on('click', '#system-error-reload', function() {
        location.href = location.href.split(/[?#]/)[0];
    });
});